import React, { useRef, useState, useEffect } from "react";
import ErrorMessage from "components/ErrorMessage";
import { AiFillCamera } from "react-icons/ai";
import { GrAdd } from "react-icons/gr";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import OImage from "components/reusable/OImage";
import { useForm } from "react-hook-form";
import OButton from "components/reusable/OButton";
import { apiPost } from "utils/apiFetch";
import { useNavigate } from "react-router-dom";
import apiPath from "../../utils/apiPath";
import { apiGet } from "../../utils/apiFetch";
import ReactQuill from "react-quill";
import helpers from "../../utils/helpers";
import useToastContext from "hooks/useToastContext";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import { validationRules } from "utils/constants";
import OFile from "components/reusable/OFile";
import OSelect from "components/reusable/OSelect";
const AddBlog = ({ addHomeBanner }) => {
  const { t } = useTranslation();
  const [content, setContent] = useState("");
  const [date, setDate] = useState("");
  const [profilePicError, setProfilePicError] = useState("");
  const [is_redirect, setRedirect] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [addMerchantLoading, setAddMerchantLoading] = useState(false);
  const profilePicRef = useRef();
  const navigate = useNavigate();
  const [Banner, setBanner] = useState([]);
  const [sidesBanner, setSideBanner] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [file, setFile] = useState([]);
  const [removedFiles, setRemovedFiles] = useState([]);
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {},
  });

  const handleFileChange = (e) => {
    const file = e?.target?.files[0];
    const isValidImage = validateFiles(file);
    if (isValidImage) {
      setProfilePic(file);
    } else {
      setProfilePic(null);
    }
  };

  const validateFiles = (uploadFile) => {
    let picError = "";
    const supportedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "video/mp4",
    ];

    if (!supportedTypes.includes(uploadFile.type)) {
      picError = "Only jpeg, jpg, png and mp4 are supported.";
    }
    if (picError) {
      setProfilePicError(picError);
      return false;
    } else {
      setProfilePicError("");
      return true;
    }
  };

  const getBack = () => {
    setRedirect(true);
    navigate("/blogs");
  };

  const getCategories = async () => {
    const path = apiPath.categoryList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      const cate = response?.docs?.map((item, i) => {
        return {
          key: item?.title,
          value: item?._id,
        };
      });
      setCategories(response?.docs);
    }
  };
  const getSubCategories = async (categoryId) => {
    const category = await categories.filter((item) => {
      return item?._id === categoryId;
    });
    setSubCategories(category[0]?.subcategories);
  };
  useEffect(() => {
    getCategories();
  }, []);

  const addMore = (item) => {
    handleFileUpload(item.target.files);
  };
  
  const remove = (index) => {
    if(index?.flag === 'fromApi') {
      const dbUrl = index?.url?.split("com/");
      setRemovedFiles([...removedFiles, { type: index?.type, url: dbUrl[1] }]);
    }
    setFile((prev) => {
      return prev.filter((res) => res !== index);
    });
  };
  const handleFileUpload = (e) => {
    for (let i = 0; i < e?.length; i++) {
      let getType = e[i].type.split("/");
      if (
        getType[1] !== undefined &&
        (getType[1] === "jpeg" ||
          getType[1] === "png" ||
          getType[1] === "jpg" ||
          getType[1] === "gif" ||
          getType[1] === "mp4")
      ) {
        setFile((prev) => {
          if (prev?.length > 0) {
            return [...prev, e[i]];
          } else {
            return [e[i]];
          }
        });
      } else {
        notification.error("Only jpeg,png,jpg,gif, mp4 formats are allowed");
      }
    }
  };

  const validate = () => {
    if (file?.length > 5) {
      notification.error("You cannot upload more than 5 files");
      return false;
    } else if ( file?.length < 1){
      notification.error("Please choose photo/video");
      return false;
    }
    for (let i = 0; i < file?.length; i++) {
      const size = file[i]?.size/(1024*1024).toFixed(2)
      if(size && size > 50){
        notification.error("You cannot upload file of more than 50mb.");
        return false;
      }
    }
    return true;
  };

  const onSubmit = async (data) => {
    try {
      let valid = validate();
      if(valid){
        const formData = new FormData();
        formData.append("title", data?.title);
        formData.append("authorName", data?.authorName);
        formData.append("category", data?.categoryId);
        data?.subCategoryId&& formData.append("subCategory", data?.subCategoryId);
        formData.append("description", data?.description);
        if (file?.length > 0) {
          for (let i = 0; i < file?.length; i++) {
            formData.append("files", file[i]);
          }
        }
        console.log('formData: ', formData);
        const path = apiPath.ListBlog;
        const result = await apiPost(path, formData);
        if (result?.data?.success) {
          setRedirect(true);
          notification.success(result.data.message);
        } else {
          notification.error(result.data.message);
        }
      }
    } catch (error) {
      console.log("error in get all users list==>>>>", error.message);
    }
    setAddMerchantLoading(false);
  };

  if (is_redirect) {
    return navigate("/blogs");
  }

  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <h2 className="font-medium text-black dark:text-white mb-3 text-xl">
          {t("ADD_BLOG")}
        </h2>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="title"
                  id="title"
                  maxLength={100}
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("title", {
                    required: t("VALIDATION_TITLE_REQUIRED"),
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_TITLE_MIN_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("title", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="title"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_TITLE")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.title?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="authorName"
                  id="authorName"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={31}
                  {...register("authorName", {
                    required: t("VALIDATION_AUTHOR_REQUIRED"),
                    pattern: {
                      value: validationRules.characters,
                      message: t("VALIDATION_AUTHOR_PATTERN"),
                    },
                    validate: (value) => {
                      const val = value.trim();
                      return val.length < 3
                        ? t("VALIDATION_AUTHOR_MIN_LENGTH")
                        : val.length > 30
                        ? t("VALIDATION_AUTHOR_MAX_LENGTH")
                        : true;
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("authorName", value, { shouldValidate: true });
                  }}
                />
                <label
                  htmlFor="authorName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_AUTHOR_NAME")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.authorName?.message} />
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                  id="categoryId"
                  name="categoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("categoryId", {
                    required: t("VALIDATION_SELECT_CATEGORY"),
                    onChange: (e) => {
                      getSubCategories(e.target.value);
                    },
                  })}
                >
                  <option defaultValue value="">
                    {t("SELECT_CATEGORY")}
                  </option>
                  {categories &&
                    categories.length !== 0 &&
                    categories?.map(({ title, _id }) => (
                      <option key={_id} value={_id}>
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="name"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CATEGORY")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.categoryId?.message} />
              </div>
            </div>
            {/* <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <select
                  id="subCategoryId"
                  name="subCategoryId"
                  className="block  py-4 px-3 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("subCategoryId", {
                    required: false,
                  })}
                  // value={filterData?.category}
                  // onChange={(e)=>statusPage(e)}
                >
                  <option defaultValue value="">
                    {t("SELECT_SUB_CATEGORY")}
                  </option>
                  {subCategories &&
                    subCategories.length !== 0 &&
                    subCategories?.map(({ title, _id }) => (
                      <option key={_id} value={_id}>
                        {title}
                      </option>
                    ))}
                </select>
                <label
                  htmlFor="subCategoryId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_SUBCATEGORIES")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.subCategoryId?.message} />
              </div>
            </div> */}
            <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                  type="text"
                  name="description"
                  id="description"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("description", {
                    required: t("VALIDATION_DESCRIPTION_REQUIRED"),
                    validate: (value) => {
                      return value.split(' ').length <= 1000
                        ? value.split(' ').length > 10
                          ? true
                          : 'Description should contains at least 10 words.'
                        : 'Description should not exceed 1000 words.'
                    },
                  })}
                  onChange={(event) => {
                    var value = event.target.value;
                    value = value.trimStart();
                    setValue("description", value, {
                      shouldValidate: true,
                    });
                  }}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.description?.message} />
              </div>
            </div>

            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                onClick={getBack}
              >
                {t("O_BACK")}
              </button>
              <div className="text-center">
                <OButton
                  label={t("O_ADD")}
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
              {t("O_UPLOAD_IMAGE_VIDEO")}
              </h3>
            </div>
            <div className="flex relative text-center h-full items-baseline justify-center border border-dashed mb-5 rounded-sm p-[20px] min-h-[158px]">
                <input
                  className="absolute opacity-0 top-0 right-0 left-0 bottom-0 cursor-pointer"
                  type="file"
                  onChange={(e) => {
                    addMore(e);
                  }}
                  multiple
                  accept="image/png, image/jiffy, image/jpeg, image/jpg, video/mp4"
                  onClick={(e) => (e.target.value = null)}
                />
                <div className="flex flex-col items-center">
                  <img src="/images/photoupload.svg" className="mb-2" />
                  <strong>{t("ADD_MORE")}</strong>
                  <span style={{ fontSize: "14px", fontWeight: "500" }}>
                    {t("MAX_5_FILE_UPLOAD_TITLE")}
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-5">
                {file?.length > 0 &&
                  file?.map((res, index) => {
                    return (
                      <div className="relative" key={index}>
                        <figure className="">
                          {res?.type === "video/mp4" || res?.type === "video" ? (
                            <video
                              controls
                              className="h-48 w-48"
                              src={
                                typeof res === "object" &&
                                res?.flag !== "fromApi"
                                  ? URL.createObjectURL(res)
                                  : res?.url
                              }
                            />
                          ) : (
                            <img
                              className="h-48 w-48"
                              src={
                                typeof res === "object" &&
                                res?.flag !== "fromApi"
                                  ? URL.createObjectURL(res)
                                  : res?.url
                              }
                            />
                          )}
                        </figure>
                        <a
                          href="javascript:void(0)"
                          onClick={() => remove(res)}
                          className="absolute top-3 right-11"
                        >
                          <img src="/images/photo-crose.svg" alt='img' />
                        </a>
                      </div>
                    );
                  })}
              </div>
            {/* {!profilePic ? (
              <div
                id="FileUpload"
                className="relative mb-5.5 block w-full cursor-pointer appearance-none rounded border-2 border-dashed border-primary bg-gray py-5 px-4 dark:bg-meta-4 sm:py-7.5"
              >
                <input
                  type="file"
                  multiple
                  accept="image/png, image/jpg, image/jpeg, video/mp4"
                  name="image"
                  ref={profilePicRef}
                  onChange={(e) => addMore(e)}
                  className="absolute inset-0 z-50 m-0 h-full w-full cursor-pointer p-0 opacity-0 outline-none"
                />
                <div className="flex flex-col items-center justify-center space-y-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full border border-stroke bg-white dark:border-strokedark dark:bg-boxdark">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.99967 9.33337C2.36786 9.33337 2.66634 9.63185 2.66634 10V12.6667C2.66634 12.8435 2.73658 13.0131 2.8616 13.1381C2.98663 13.2631 3.1562 13.3334 3.33301 13.3334H12.6663C12.8431 13.3334 13.0127 13.2631 13.1377 13.1381C13.2628 13.0131 13.333 12.8435 13.333 12.6667V10C13.333 9.63185 13.6315 9.33337 13.9997 9.33337C14.3679 9.33337 14.6663 9.63185 14.6663 10V12.6667C14.6663 13.1971 14.4556 13.7058 14.0806 14.0809C13.7055 14.456 13.1968 14.6667 12.6663 14.6667H3.33301C2.80257 14.6667 2.29387 14.456 1.91879 14.0809C1.54372 13.7058 1.33301 13.1971 1.33301 12.6667V10C1.33301 9.63185 1.63148 9.33337 1.99967 9.33337Z"
                        fill="#3C50E0"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.5286 1.52864C7.78894 1.26829 8.21106 1.26829 8.4714 1.52864L11.8047 4.86197C12.0651 5.12232 12.0651 5.54443 11.8047 5.80478C11.5444 6.06513 11.1223 6.06513 10.8619 5.80478L8 2.94285L5.13807 5.80478C4.87772 6.06513 4.45561 6.06513 4.19526 5.80478C3.93491 5.54443 3.93491 5.12232 4.19526 4.86197L7.5286 1.52864Z"
                        fill="#3C50E0"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.99967 1.33337C8.36786 1.33337 8.66634 1.63185 8.66634 2.00004V10C8.66634 10.3682 8.36786 10.6667 7.99967 10.6667C7.63148 10.6667 7.33301 10.3682 7.33301 10V2.00004C7.33301 1.63185 7.63148 1.33337 7.99967 1.33337Z"
                        fill="#3C50E0"
                      ></path>
                    </svg>
                  </span>
                  <p className="font-medium text-sm">
                    <span className="text-primary">Click to upload</span>
                  </p>
                </div>
              </div>
            ) : (
              <div className="relative">
              <button
                  title="Close"
                  className=" z-10 text-white rounded-full bg-red-500 hover:text-red-500 hover:bg-white text-3xl leading-none font-extralight outline-none focus:outline-none absolute top-2 right-[12px] w-[40px] h-[40px]"
                  onClick={() => setProfilePic(null)}
                >
                  ×
                </button>
                <OFile
                  type={profilePic?.type}
                  src={profilePic ? URL.createObjectURL(profilePic) : ""}
                  fallbackUrl="/images/imagesBanner.png"
                  className="w-full h-full border relative"
                  alt=""
                />
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBlog;
